import { TextLink } from '@/components/TextLink';
import { Links } from '@/config/links';

export const SECTION_DATA = [
  {
    title: 'Über neolexon',
    content:
      'Neolexon ist ein digitales Unterstützungssystem für die Sprachtherapie und ist als Medizinprodukt eingetragen. Das Projekt neolexon ist eine Ausgründung der Entwicklungsgruppe Klinische Neuropsychologie des Instituts für Phonetik und Sprachverarbeitung, Ludwig-Maximilians-Universität München. Ein interdisziplinäres Team aus Sprachtherapeut:innen und Informatiker:innen ist für die Entwicklung von neolexon verantwortlich. Das Feedback von Patient:innen und Therapeut:innen wird stets in die Weiterentwicklung von neolexon mit einbezogen.',
  },
  {
    title: 'Autorinnen von neolexon',
    content:
      'Dr. Mona Späth und Dr. Hanna Jakob, Sprachtherapeutinnen, M.A.,Geschäftsführung Limedix GmbH',
  },
  {
    title: 'Zweckbestimmung',
    content: `Neolexon Aphasie bietet eine digitale Sprachtherapie für Patienten mit Aphasie und/oder Sprechapraxie, die aufgrund einer neurologischen Erkrankung sprachliche Beeinträchtigungen haben. Die digitale Anwendung soll die logopädische Therapie zielgerichtet intensivieren und die sprachlichen Fähigkeiten verbessern. neolexon Aphasie ist nur anwendbar als Ergänzung zur Behandlung beim Logopäden/Sprachtherapeuten. Die Anwendung ist nicht dafür bestimmt, Informationen für diagnostische oder therapeutische Entscheidungen zu liefern.`,
  },
  {
    title: 'Datenschutz',
    content:
      'Datenschutz hat bei neolexon höchste Priorität. Die geltenden Datenschutzbestimmungen nach DSGVO und BDSG-neu werden eingehalten. Weitere Informationen finden Sie in unserer',
    children: {
      Component: TextLink,
      componentProps: {
        href: Links.datenschutz.href,
        children: 'Datenschutzerklärung',
      },
    },
  },
];
